import m from "./../../../dist/es2015/locales/el_GR.js";
export const am5locales_el_GR = m;